import { Component, OnInit } from '@angular/core';
import { first, map, take } from 'rxjs/operators';
import { DbService } from 'src/app/core/services/db.service';

@Component({
  selector: 'app-show-terms',
  templateUrl: './show-terms.component.html',
  styleUrls: ['./show-terms.component.scss'],
})
export class ShowTermsComponent implements OnInit {
  service;
  constructor(private db: DbService) {}

  async ngOnInit() {
    this.service = await this.db
      .doc$('admin/adminInfo')
      .pipe(take(1))
      .toPromise()
      .then(val => val.service);
  }
}
